import { useState, useEffect } from 'react'

import { MenuItem, Modal, Grid, Paper, TextField, FormControl, Box,
  InputLabel, Select, Fade, Backdrop, Checkbox, FormControlLabel, Button, Typography } from '@material-ui/core'

import axiosConfig from 'utils/axiosConfig'

const DuplicateExamModal = ({exam, state, onClose, classrooms}) => {
  const [showDuplicateExamModal, setShowDuplicateExamModal] = useState(false)

  const [name, setName] = useState(`${exam.name} (Duplicate)`)
  const [nameHelperText, setNameHelperText] = useState("")
  const [nameError, setNameError] = useState(false)

  const [description, setDescription] = useState(exam.description)
  const [descriptionHelperText, setDescriptionHelperText] = useState("")
  const [descriptionError, setDescriptionError] = useState(false)

  const [classroom, setClassroom] = useState(exam.class_code)
  const [classroomError, setClassroomError] = useState(false)

  const [shuffleQuestions, setShuffleQuestions] = useState(false)

  const [duplicating, setDuplicating] = useState(false)

  const toggleShuffleQuestions = () => {
    setShuffleQuestions(!shuffleQuestions)
  }

  const duplicateExam = () => {
    setDuplicating(true)

    setNameError(false)
    setDescriptionError(false)
    setClassroomError(false)

    setNameHelperText("")
    setDescriptionHelperText("")

    let hasError = false

    if (name === "") {
      setNameHelperText('This is field is required')
      setNameError(true)
      hasError = true
    }

    if (description === "") {
      setDescriptionHelperText('Please describe the examination')
      setDescriptionError(true)
      hasError = true
    }

    if (classroom === "") {
      setClassroomError(true)
    }

    if (hasError) {
      return
    }

    let examData = {
      exam: exam.id,
      name, description, classroom, shuffleQuestions
    }

    axiosConfig.post(`examinations/${exam.id}/duplicate`, examData)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success && responseData.errors !== undefined) {

          if (responseData.errors.name !== undefined) {
            setNameHelperText(responseData.errors.name)
            setNameError(true)
          }

        }
      })

    onClose()
  }

  const handleClose = () => {
    setShowDuplicateExamModal(false)
    onClose()
  }

  useEffect(() => {
    setShowDuplicateExamModal(state)
  }, [state])

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={showDuplicateExamModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showDuplicateExamModal}>
          <Grid container style={{marginTop: '50px'}}>
            <Grid item md={8} lg={6} className="new-examination-modal">
              <Paper className="new-examination-container">

                <Box marginBottom={3}>
                  <Typography variant="h6" component="h1">Duplicating: {exam.name}</Typography>
                </Box>

                <TextField
                  label="What do you want to call your examination?"
                  helperText={nameHelperText}
                  fullWidth
                  error={nameError}
                  onChange={(e) =>setName(e.target.value)}
                  value={name}
                />

                <TextField
                  label="A short description of the examination?"
                  helperText={descriptionHelperText}
                  fullWidth
                  error={descriptionError}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />

                <FormControl fullWidth>
                  <InputLabel id="class" error={classroomError}>Classroom</InputLabel>
                  <Select
                    labelId="class"
                    value={classroom}
                    onChange={(e) => setClassroom(e.target.value)}
                    error={classroomError}
                  >
                    {classrooms.length > 0 && classrooms.map((c) => (
                      <MenuItem value={c.class_code} key={c.class_code}>{`${c.class_code} - ${c.name}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={shuffleQuestions}
                      onChange={toggleShuffleQuestions}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  }
                  label="Shuffle questions"
                />

                <div style={{display: 'flex', justifyContent: 'end'}}>
                  <Button style={{
                      backgroundColor: '#EF6527',
                      padding: '10px',
                      borderRadius: '7px',
                      color: 'white',
                    }}
                    onClick={duplicateExam}
                  >
                    {!duplicating && <><i className="fa fa-copy"></i> &nbsp; Duplicate</>}
                    {duplicating && <><i className="fa fa-spinner fa-spin"></i> &nbsp; Creating copy...</>}
                  </Button>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Fade>
      </Modal>
    </div>
  )
}

export default DuplicateExamModal